import { render, staticRenderFns } from "./OnstarOptions.vue?vue&type=template&id=a8283b1e&scoped=true&"
import script from "./OnstarOptions.vue?vue&type=script&lang=js&"
export * from "./OnstarOptions.vue?vue&type=script&lang=js&"
import style0 from "./OnstarOptions.vue?vue&type=style&index=0&id=a8283b1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8283b1e",
  null
  
)

export default component.exports